import images from "../images/images";

function LocationImageDisplay({ imageKey,dynamicHeight }) {
    if (!images || !imageKey || !location) return null;
    const defaultHeight = "35vh";
    return images[imageKey] ? (
      <img
        src={images[imageKey]}
        alt={imageKey}
        className="global-bottom-illustration"
        style={{ height: dynamicHeight || defaultHeight }}
      />
    ) : (
      <div>Image not available</div>
    );
  };
  
  export  {LocationImageDisplay};
  